import tools from "./tools";

// Une fiche client Modulr de type '0' est la fiche personnelle d'un
// particulier (PER-2209) — par opposition aux fiches sociétés.
export const estFichePersonnelle = (client) => String(client?.type) === "0";

export const identiteParticulier = (client) =>
  [tools.getGender(client.gender), client.firstname, client.lastname]
    .filter(Boolean)
    .join(" ");

export const libelleFiche = (client) =>
  estFichePersonnelle(client) ? identiteParticulier(client) : client.company;

// Même distinction sur le client d'une quittance à payer
// (`receipts/mines/to-pay`, PER-2211) : le read model expose `typeClient`
// et des clés françaises (civilite/nom/prenom/nomSociete), pas le modèle Client.
export const estClientQuittancePersonnel = (client) =>
  String(client?.typeClient) === "0";

export const libelleClientQuittance = (client) =>
  estClientQuittancePersonnel(client)
    ? [tools.getGender(client.civilite), client.prenom, client.nom]
        .filter(Boolean)
        .join(" ")
    : client?.nomSociete;
